import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map-parkInfo",
  "use": "icon-map-parkInfo-usage",
  "viewBox": "0 0 18 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18 22\" id=\"icon-map-parkInfo\">\n<style type=\"text/css\">\n\t#icon-map-parkInfo .st0{fill-rule:evenodd;clip-rule:evenodd;}\n</style>\n<path class=\"st0\" d=\"M14,0H4C1.79,0,0,1.79,0,4v14c0,2.21,1.79,4,4,4h10c2.21,0,4-1.79,4-4V4C18,1.79,16.21,0,14,0z M4,4h6v1H4V4z\n\t M14,17H4v-1h10V17z M14,13H4v-1h10V13z M14,9H4V8h10V9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol